'use client';

import { trackCTA } from '@/storyblok/wirfuersklima/helper/tracking';
import { linkToString } from '@/storyblok/wirfuersklima/helper/urls';
import type { MultilinkStoryblok } from '@/storyblok/wirfuersklima/types';
import Link from 'next/link';
import type { ReactNode } from 'react';

export interface CtaLinkProps {
  children: ReactNode;
  label: string;
  link: MultilinkStoryblok;
  className?: string;
}

const CtaLink: React.FC<CtaLinkProps> = (props) => {
  return (
    <Link
      href={linkToString(props.link)}
      className={props.className ?? 'textlink'}
      onClick={() => trackCTA(props.label, linkToString(props.link))}
    >
      {props.children}
    </Link>
  );
};

export default CtaLink;
